







import { Component, Prop, Vue } from 'vue-property-decorator';

import { hubSpotUrl } from '@/modules/hub-spot/hub-spot-url';

@Component({})
export default class HubSpotLink extends Vue {
	@Prop({ required: false, type: String })
	private hubSpotId!: string | null;

	@Prop({ required: true, type: String })
	private hubSpotObjectType!: string | null;

	public get hubSpotUrl(): string | null {
		if (!this.hubSpotId) {
			return null;
		}
		return `${hubSpotUrl()}/${this.hubSpotObjectType}/${this.hubSpotId}`;
	}
}
